import { createSlice } from "@reduxjs/toolkit";

interface State {
  data: any[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: State = {
  data: null,
  loading: true,
  error: null,
};

export const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    initialNotifications: (state, action) => {
      state.data = action.payload.data;
      state.loading = false;
      state.error = null;
    },
    addNotification: (state, action) => {
      state.data?.unshift(action.payload);
    },
    showNotificationsError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { addNotification, initialNotifications, showNotificationsError } =
  notificationsSlice.actions;

export default notificationsSlice.reducer;
